import { ActionIcon, useMantineColorScheme } from "@mantine/core";

import { IconSortDown, IconSortUp } from "@/components/icons";

import type { FC } from "react";

export type SortActionDirection = "best" | "worst";

export type SortActionIconProps = {
  active: boolean;
  onClick: () => void;
  type: SortActionDirection;
  ariaLabel: string;
};

export const SortActionIcon: FC<SortActionIconProps> = ({ active, onClick, type, ariaLabel }) => {
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const Icon = type === "best" ? IconSortUp : IconSortDown;

  return (
    <ActionIcon
      size="md"
      onClick={onClick}
      aria-label={ariaLabel}
      bg={
        active
          ? isDark
            ? "var(--mantine-color-primaryDark-7)"
            : "var(--mantine-color-primary-0)"
          : isDark
            ? "inherit"
            : "inherit"
      }
      c={
        active
          ? isDark
            ? "var(--mantine-color-primary-3)"
            : "var(--mantine-color-primary-7)"
          : isDark
            ? "var(--mantine-color-primary-2)"
            : "inherit"
      }
    >
      <Icon data-active={active} />
    </ActionIcon>
  );
};
